import request from '@/utils/request'



// 纺织品，水龙头权限列表
export function typeListDetail () {
  return request({
    url: '/product/brand/detailList?country=US',
    method: 'get'
  })
}


// 品牌列表
export function brandList () {
  return request({
    url: '/product/brand/simpleList?country=US',
    method: 'get'
  })
}

// 类型列表
export function typeList () {
  return request({
    url: '/product/type/simpleList',
    method: 'get'
  })
}

// 供应商列表
export function supplierList () {
  return request({
    url: '/purchase/supplier/simpleList',
    method: 'get'
  })
}

// 仓库列表
export function warehouselistList () {
  return request({
    url: '/purchase/warehouselist/simpleList',
    method: 'get'
  })
}

// 快递商列表
export function expressagentList () {
  return request({
    url: '/warehouse/expressagent/simpleList',
    method: 'get'
  })
}

// 快递方式列表
export function expresstypeList () {
  return request({
    url: '/warehouse/expresstype/simpleList',
    method: 'get'
  })
}

// 审核人列表
export function verifyList () {
  return request({
    url: '/auth/admin/verifyList',
    method: 'get'
  })
}

// 根据功能获取所有条件的下拉列表
export function getSelectList(data) {
  return request({
    url: "/ajax/getSelectList/name/"+data,
    method: "get"
  });
}


//更新日志
export function updateLog(data) {
  return request({
    url: "/ajax/updateLog",
    method: "get"
  });
}
//下载记录
export function downLog(data) {
  return request({
    url: "/ajax/downLog",
    method: "get"
  });
}




// WEBPACK FOOTER //
// ./src/api/simpleList.js